// Wider than ContentKind: covers feeds that back configuration rather than slides.
export enum FeedName {
  News = 'news',
  Birthdays = 'birthdays',
  PriorityNews = 'priority-news',
  Activities = 'activities',
  ScheduledVideo = 'scheduled-video',
  Dining = 'dining',
  DiningLocations = 'dining-locations',
  Weather = 'weather',
  Mail = 'mail',
  Configuration = 'configuration',
  Branding = 'branding',
  ServiceNames = 'service-names',
  YoutubeLive = 'youtube-live'
}
